import { updateCartAttributes } from '../resources/shopify-cart'
import { getCookie, setCookie } from '../utilities/cookies'

if (Pura?.dev?.enable_vwo_shipping_test) {
  const vwoShippingTestGroup = getCookie('vwo_shipping_test_group')
  const vwoCampaignId = Pura?.dev?.vwo_campaign_id.toString() || false

  if (!vwoShippingTestGroup) {
    window.VWO = window.VWO || []
    window.VWO.push([
      'onVWOLoaded',
      (data) => {
        if (!data || !data[0]) return
        const campaignData = data[0]

        Object.entries(campaignData).forEach(([campaignId, variationId]) => {
          try {
            if (window._vwo_exp && window._vwo_exp[campaignId]) {
              const variationName =
                window._vwo_exp[campaignId].comb_n[
                  variationId as string
                ].toLowerCase()

              if (campaignId === vwoCampaignId) {
                setCookie('vwo_shipping_test_group', variationName, 30)
                updateCartAttributes({
                  vwo_shipping_test_group: variationName,
                })
              }
            }
          } catch (error) {
            console.error('Error processing campaign:', campaignId, error)
          }
        })
      },
    ])
  }
}
